import { render, staticRenderFns } from "./CompareTransactionsPage.vue?vue&type=template&id=203531a8&scoped=true"
import script from "./CompareTransactionsPage.vue?vue&type=script&lang=js"
export * from "./CompareTransactionsPage.vue?vue&type=script&lang=js"
import style0 from "./CompareTransactionsPage.vue?vue&type=style&index=0&id=203531a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203531a8",
  null
  
)

export default component.exports